<script lang="ts">
</script>

<svg viewBox="0 0 20 21.3" width={20} height={21.3}>
	<circle cx="8.75" cy="8.75" r="8.25" />
	<line x1={20} y1={21.3} x2={14} y2={14.75} />
</svg>

<style lang="scss">
	circle {
		/* fill: black; */
		fill: transparent;
		stroke: white;
		stroke-width: 1;
	}

	line {
		stroke: white;
		stroke-width: 1;
	}

</style>
